import React from 'react'
import Page from '../components/Page'
import { Button, Card, CardBody, CardHeader, Col, Label, Row, Table, Modal, ModalBody, ModalFooter, ModalHeader, Nav, NavItem, NavLink, TabContent, TabPane, Form, FormFeedback, FormGroup, FormText, Input } from 'reactstrap'
import axios from '../utils/posAxios'
import StorageService from '../services/StorageService'
import NotificationSystem from 'react-notification-system'
import { NOTIFICATION_SYSTEM_STYLE } from '../utils/constants'
import { Redirect } from 'react-router'
import classnames from 'classnames'
import moment from 'moment-timezone'
import PaymentReport from '../components/PaymentReport'
import SalesReport from '../components/SalesReport'
import CustomerSalesReport from '../components/CustomerSalesReport'
import OrderSummary from '../components/OrderSummary'
import OrderSchedule from '../components/OrderSchedule'
import OrderScheduleBreakdown from '../components/OrderScheduleBreakdown'
import OrderScheduleList from '../components/OrderScheduleList'
import ScheduleOrderList from '../components/ScheduleOrderList'
import PackingListOrderDt from '../components/PackingListOrderDt'
import SupplierReport from '../components/SupplierReport'

class PosReportPage extends React.Component {
  _isMounted = true
  reportDetail = StorageService.getSession('reportPage')
  comp = StorageService.getSession('selected_org')
  posreport = StorageService.getSession('posreport')
  constructor() {
    super()
    this.state = {
      Role: this.comp.Role,
      redirect: false,
      isLoading: true,
      storeList: [],
      activeTab: this.posreport && this.posreport.activeTab ? this.posreport.activeTab : '1',
      tabList: [
        { name: 'Payment' },
        { name: 'Orders' },
        { name: 'Order Fulfilment' },
        { name: 'Item Sales' },
        { name: 'Sales by Customer' },
        { name: 'Item Fulfilment' },
        { name: 'Item Fulfilment (Breakdown)' },
        { name: 'Supplier' },
        // { name: 'Packing List (Order Date)' },
      ],
      stateList: [],
    }
  }

  componentDidMount() {
    this.getUserStore()
    this.getOrderState()
  }

  componentWillUnmount() {
    this._isMounted = false
  }

  toggleTab(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      })
      //this.filterOrder(this.state.orderList, tab);
      let data = this.posreport ? this.posreport : {}
      data['activeTab'] = tab
      StorageService.setSession('posreport', data)
      this.posreport = StorageService.getSession('posreport')
    }
  }

  order = (store_id, id) => {
    this.props.history.push({
      pathname: '/posorder/store/' + store_id + '/' + id,
      state: { prevPath: '/posreport' },
    })
  }

  getUserStore = () => {
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_API_URL
    const data = {
      session_key: user.session_key,
      CompanyID: comp.CompanyID,
      ProfileID: user.userId,
    }

    axios
      .post(url + ':3000/v1/user/getContentAccess', data)
      .then(response => {
        const result = response.data
        if (result.error == true && result.message != 'Success') {
          alert(result.message)
          return
        }
        StorageService.setSession('user_access', result.data)
        this.getStoreList()
      })
      .catch(error => {
        alert(error)
      })
  }

  getStoreList() {
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const access = StorageService.getSession('user_access')
    const url = process.env.REACT_APP_UNITY_API2_URL
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      company_id: comp.CompanyID,
    }

    axios
      .post(url + ':3001/v1/store', data)
      .then(response => {
        const result = response.data
        if (result.error == true && result.message != 'Success') {
          alert(result.message)
          return
        }
        if (this._isMounted) {
          let storeList = []
          for (let i of access.store) {
            for (let j of result.data) {
              if (j.store_id === i.store_id) {
                if (i.role == 'Admin' || i.role == 'Supervisor' || i.role == 'Financial' || i.role == 'Manager' || i.role == 'Superuser') {
                  storeList.push(j)
                }
              }
            }
          }
          this.setState({
            storeList: storeList,
          })
        }
      })
      .catch(error => {
        alert(error)
      })
  }

  getOrderState() {
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      company_id: comp.CompanyID,
    }

    axios
      .post(url + ':3003/v1/order/state', data)
      .then(response => {
        const result = response.data
        if (result.error == true && result.message != 'Success') {
          alert(result.message)
          return
        }
        if (this._isMounted) {
          this.setState({
            stateList: result.data,
          })
        }
      })
      .catch(error => {
        alert(error)
      })
  }

  render() {
    const { activeTab, Role, storeList } = this.state

    return (
      <Page className="PosReportPage sidebar-open" title="Report" breadcrumbs={[{ name: 'Report', active: true, path: '/posreport' }]}>
        <NotificationSystem dismissible={false} ref={notificationSystem => (this.notificationSystem = notificationSystem)} style={NOTIFICATION_SYSTEM_STYLE} />
        {/* <Row>
          <Col xl={12} lg={12} md={12}>
            <Card>
              <CardBody>
                <Nav tabs className="ps-tab">
                  {this.state.tabList.map((item, index) => {
                    return (
                      <NavItem key={item.name}>
                        <NavLink
                          className={classnames({
                            active: activeTab === (index + 1).toString(),
                          })}
                          onClick={() => {
                            this.toggleTab((index + 1).toString());
                          }}
                        >
                          {item.name}
                        </NavLink>
                      </NavItem>
                    );
                  })}
                </Nav>

                <TabContent activeTab={activeTab}>
                  {this.state.storeList.length > 0 &&
                    this.state.stateList.length > 0 && (
                      <>
                        <TabPane tabId="1" className="py-3">
                          <PaymentReport data={this.state} />
                        </TabPane>
                        <TabPane tabId="2" className="py-3">
                          <SalesReport data={this.state} />
                        </TabPane>
                        <TabPane tabId="3" className="py-3">
                          <OrderSummary data={this.state} />
                        </TabPane>
                        <TabPane tabId="4" className="py-3">
                          <OrderSchedule data={this.state} />
                        </TabPane>
                        <TabPane tabId="5" className="py-3">
                          <OrderScheduleList
                            data={this.state}
                            order={this.order}
                          />
                        </TabPane>
                        <TabPane tabId="6" className="py-3">
                          <ScheduleOrderList
                            data={this.state}
                            order={this.order}
                          />
                        </TabPane>
                      </>
                    )}
                </TabContent>
              </CardBody>
            </Card>
          </Col>
        </Row> */}
        {(Role === 'Superuser' || Role === 'Admin' || Role === 'Supervisor' || Role === 'Manager' || Role === 'Financial' || storeList.length > 0) && (
          <Row>
            <Col xl={12} lg={12} md={12}>
              <Card>
                <CardBody>
                  <Nav tabs className="ps-tab">
                    {this.state.tabList.map((item, index) => {
                      return (
                        <NavItem key={item.name}>
                          <NavLink
                            className={classnames({
                              active: activeTab === (index + 1).toString(),
                            })}
                            onClick={() => {
                              this.toggleTab((index + 1).toString())
                            }}>
                            {item.name}
                          </NavLink>
                        </NavItem>
                      )
                    })}
                  </Nav>

                  <TabContent activeTab={activeTab} className="ps-tab-content">
                    {this.state.storeList.length > 0 && this.state.stateList.length > 0 && (
                      <>
                        {/* Payment */}
                        <TabPane tabId="1" className="py-3">
                          <PaymentReport data={this.state} />
                        </TabPane>
                        {/* Schedule Orders */}
                        <TabPane tabId="2" className="py-3">
                          <ScheduleOrderList data={this.state} order={this.order} />
                        </TabPane>
                        <TabPane tabId="3" className="py-3">
                          <OrderScheduleList data={this.state} order={this.order} />
                        </TabPane>
                        {/* Item Sales (Order Date) */}
                        <TabPane tabId="4" className="py-3">
                          <SalesReport data={this.state} />
                        </TabPane>
                        <TabPane tabId="5" className="py-3">
                          <CustomerSalesReport data={this.state} />
                        </TabPane>
                        {/* Removed */}
                        {/* <TabPane tabId="3" className="py-3">
                            <OrderSummary data={this.state} />
                          </TabPane> */}
                        {/* Item Sales (Scheduled Date) */}
                        <TabPane tabId="6" className="py-3">
                          <OrderSchedule data={this.state} />
                        </TabPane>
                        <TabPane tabId="7" className="py-3">
                          <OrderScheduleBreakdown data={this.state} />
                        </TabPane>
                        <TabPane tabId="8" className="py-3">
                          <SupplierReport data={this.state} />
                        </TabPane>
                        {/* Packing List (Order Date) Removed on 2021-03-19 */}
                        {/* <TabPane tabId="5" className="py-3">
                            <PackingListOrderDt
                              data={this.state}
                              order={this.order}
                            />
                          </TabPane> */}
                        {/* Packing List (Scheduled Date) */}
                      </>
                    )}
                  </TabContent>
                </CardBody>
              </Card>
            </Col>
          </Row>
        )}
      </Page>
    )
  }
}

export default PosReportPage
